/**
 * Reusable surface treatments — colour, border, radius and elevation only.
 * Padding stays with the component.
 */
export const layerStyles = {
  /** Standard card. Barely lifted: the surface step does the separating. */
  card: {
    value: {
      bg: 'bg.surface',
      borderWidth: '1px',
      borderColor: 'border.default',
      borderRadius: 'lg',
      boxShadow: 'card',
    },
  },
  /** Same shape with no elevation, for surfaces sitting in a grid. */
  panel: {
    value: {
      bg: 'bg.surface',
      borderWidth: '1px',
      borderColor: 'border.default',
      borderRadius: 'lg',
    },
  },
  /** Flat region inside a card. Never a nested card. */
  inset: {
    value: {
      bg: 'bg.surfaceSubtle',
      borderRadius: 'md',
    },
  },
  tableContainer: {
    value: {
      bg: 'bg.surface',
      borderWidth: '1px',
      borderColor: 'border.default',
      borderRadius: 'lg',
      overflow: 'hidden',
      boxShadow: 'card',
    },
  },
  /** Floating surfaces: menus and popovers. */
  menuSurface: {
    value: {
      bg: 'bg.surfaceRaised',
      borderWidth: '1px',
      borderColor: 'border.default',
      borderRadius: 'md',
      boxShadow: 'floating',
    },
  },
  /** Modal surfaces take the largest radius and the deepest shadow. */
  dialogSurface: {
    value: {
      bg: 'bg.surfaceRaised',
      borderWidth: '1px',
      borderColor: 'border.default',
      borderRadius: 'xl',
      boxShadow: 'dialog',
    },
  },
}
